<template>
  <div class="tipModal">
    <artmisads-modal
      v-model:open="visible"
      :title="$t('seller.brandsPage.tipModalTitle')"
      :ok-text="$t('seller.brandsPage.tipModalLeave')"
      :cancel-text="$t('seller.common.cancel')"
      @ok="handleConfirm"
      @cancel="handleCancel"
    >
     
        <div class="modal-content">
          <p>
            {{ $t('seller.brandsPage.tipModalLeaveBody') }}
          </p>
        </div>
     
    </artmisads-modal>
  </div>
</template>
<script setup>
import { ref, defineExpose,defineEmits } from 'vue'

const visible = ref(false)
const content = ref('')
const confirmText = ref('Leave')
const cancelText = ref('Cancel')
const emit = defineEmits(['confirm', 'cancel'])
const handleCancel = () => {
  visible.value = false
  emit('cancel')
}
const handleConfirm = () => {
  visible.value = false
  emit('confirm')
}
const showModal = () => {
  visible.value = true
}
defineExpose({
  showModal
})
</script>
<style scoped lang="less">
.modal-content {
  font-family: Sora;
  font-weight: 500;
  font-size: 18px;
  color: #0F0629;
}
</style>